/* global appData */
/* global document */

import $ from 'jquery';

function getContent( endpoint ) {
	return $.get(`${appData.root}${endpoint}`);
}

export const RestComponent = {
	props: {
		transition: {
			type: String,
			default: 'slide',
		},
	},
	data: () => ({
		content: null,
		getPostsResult: [],
		loading: false,
		resetOnce: false,
	}),
	beforeRouteEnter( to, from, next ) {
		const endpoint = to.meta.endpoint;
		if ( endpoint === null ) {
			next();
		}
		// Get the content
		getContent( endpoint )
		.then(data => next( (vm) => {
			vm.$data.content = data;
			vm.$data.transition = to.params.transition !== undefined ? to.params.transition : 'fade' ;
			vm.$route.meta.title = data.hasOwnProperty('metaTitle') ? data.metaTitle[vm.language] : vm.$props.siteData.website_title;
			document.title = vm.$route.meta.title;
			vm.langs = ['da', 'de', 'en'];
			vm.updateLangs( vm.langs );
			if (data.hasOwnProperty('post') && !Object.keys(data.post.i18n).includes(vm.language)) {
				vm.changeLanguage('da');
			}
		}));
	},
	beforeRouteUpdate( to, from, next ) {
		const endpoint = to.meta.endpoint;
		
		if ( endpoint === null ) {
			next();
		} 
		
		// Get the content
		getContent(endpoint )
			.then( data => this.content = data )
			.then( () => next() );
	},
	beforeRouteLeave(to, from, next) {
		this.loading = true;
		this.resetOnce = false;
		to.params.transition = this.transition;
		next();
	},
	watch: {
		content() {
			this.loading = false;
			if (!this.resetOnce) {
				const contentHolder = Object.assign({}, this.content);
				this.content = null;
				this.content = contentHolder;
				this.resetOnce = true;
			}
		},
	},
	methods: {
		getPosts( endpoint ) {
			$.get( `${appData.root}${endpoint}` )
			//Return result
			.then( content => this.getPostsResult = content );
		},
		navigateLeft(to) {
			//this.transition = 'slide';
			this.$emit('updatetransition', 'slide');
			this.$nextTick(function () {
				this.$router.push(to);
			});
		},
		navigateRight(to) {
			//this.transition = 'slide-right';		
			this.$emit('updatetransition', 'slide-right');
			this.$nextTick(function () {
				this.$router.push(to);
			});
		},
		openPage(to) {
			//this.transition = 'fade';		
			this.$emit('updatetransition', 'fade');
			this.$nextTick(function () {
				this.$router.push(to);
			});
		},
	},
};







// WEBPACK FOOTER //
// ./assets/_js/mixins/rest-component.js